module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_19-91202395d24197d81f52ebfc633524ba.jpg";